import { render } from "./nuevoInstrumento.vue?vue&type=template&id=0fb8a6b8&scoped=true"
import script from "./nuevoInstrumento.vue?vue&type=script&lang=js"
export * from "./nuevoInstrumento.vue?vue&type=script&lang=js"

import "./nuevoInstrumento.vue?vue&type=style&index=0&id=0fb8a6b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fb8a6b8"]])

export default __exports__